import { PopupError } from "@components/general/popup";
import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect, useState } from "react";
import { LuCoins, LuCreditCard, LuFileBarChart } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

export const SubmenuPaymentPage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  const [popupError, setPopupError] = useState<boolean>(false);

  useEffect(() => {
    setHeader({ buttonBack: true, filter: false, title: "Pembayaran" });
  }, [setHeader]);

  return (
    <>
      <div className="tw-px-4 tw-pt-4 tw-pb-20">
        <div className="tw-px-0 card-body">
          <div className="card-body-grid">
            <div className="card-grid">
              <div
                onClick={() =>
                  navigate(linkPage.FINANCE_REQUEST_VA.replace(":type", "bill"), {
                    state: { tagihan: true, tipe: "bill" },
                  })
                }
                className="tw-m-0"
              >
                <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#ecf4ff]">
                  <LuCreditCard className="tw-text-2xl tw-text-[#3b82f6]" />
                </div>
                <div className="tw-line-clamp-1 card-name">Request VA</div>
              </div>
            </div>

            <div className="card-grid">
              <div
                onClick={() =>
                  navigate(linkPage.FINANCE_REQUEST_VA.replace(":type", "zis"), {
                    state: { tagihan: false },
                  })
                }
                className="tw-m-0"
              >
                <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#f0fdf4]">
                  <LuCoins className="tw-text-2xl tw-text-[#22c55e]" />
                </div>
                <div className="tw-line-clamp-1 card-name">VA ZIS</div>
              </div>
            </div>

            <div className="card-grid">
              <div onClick={() => navigate("/finance/data-va")} className="tw-m-0">
                <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#f1f5f9]">
                  <LuFileBarChart className="tw-text-2xl tw-text-[#64748b]" />
                </div>
                <div className="tw-line-clamp-1 card-name">Laporan</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PopupError
        open={popupError}
        title="Fitur Tidak Tersedia"
        message="Fitur ini sedang dalam perbaikan. Kami akan segera mengaktifkannya kembali."
        textConfirm="Tutup"
        onConfirm={() => setPopupError(false)}
      />
    </>
  );
};
